import { ALERT, USER } from "../../constants";
import store from "../../redux/store";
import axios from "@helpers/axios/private.axios";

export const updateVerification = () => async (dispatch) => {
  try {
    const response = await axios.get("/kyc/status");
    const kyc = response.data?.data;

    if (kyc) {
      dispatch({
        type: USER.USER_FIELD,
        payload: {
          ondato_status: kyc.ondato_status,
          is_user_verified: kyc.is_user_verified,
          kyc_submission: kyc.submission,
        },
      });
    }
  } catch (error) {
    console.log("[updateVerification status error]", error);
  }

  const state = store.getState();

  state.channel.user.listen("OndatoEvent", (e) => {
    dispatch({
      type: USER.USER_FIELD,
      payload: {
        ondato_status: e.ondato_status,
      },
    });

    if (e.ondato_status === 1 || e.ondato_status === 4) {
      dispatch({ type: ALERT.ALERT_ERROR, payload: e.message });
    } else {
      dispatch({ type: ALERT.ALERT_SUCCESS, payload: e.message });
    }
  });
};